import React from "react";
import NorrisArm from "../assets/norrisarm.jpg";
import MorganPrinting from "../assets/morganprinting.jpg";
import TerraByte from "../assets/terrabyte.png";
import CardsBJ from "../assets/blackjack.png";
import CardsTH from "../assets/texasholdem.png";

export const Work = () => {
  return (
    <div
      name="work"
      className="section w-full h-screen text-white-smoke bg-off-black snap-start snap-always"
    >
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-yellow-green">
            Work
          </p>
          <p className="py-6">// Check out some of my recent work</p>
        </div>

        {/* grid container */}
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
          {/* card container */}
          <div
            style={{ backgroundImage: `url(${NorrisArm})` }}
            className="shadow-lg shadow-ebony group container rounded-md flex justify-center text-center items-center mx-auto content-div "
          >
            {/* hover effects */}

            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-off-black tracking-wider">
                Town of Norris Arm
              </span>
              <div className="pt-8 text-center">
                <a href="https://norrisarm.ca" target="_blank">
                  <button className="text-center rounderd-lg px-4 py-2 m-2 bg-salmon text-off-black font-bold text-lg">
                    Live Demo
                  </button>
                </a>
                <a href="#">
                  <button className="text-center rounderd-lg px-4 py-2 m-2 bg-salmon text-off-black font-bold text-lg">
                    Case Study Coming Soon
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* card container */}
          <div
            style={{ backgroundImage: `url(${TerraByte})` }}
            className="shadow-lg shadow-ebony group container rounded-md flex justify-center text-center items-center mx-auto content-div"
          >
            {/* hover effects */}

            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-off-black tracking-wider">
                TerraByte Solutions
              </span>
              <div className="pt-8 text-center">
                <a href="https://terrabyte.solutions" target="_blank">
                  <button className="text-center rounderd-lg px-4 py-2 m-2 bg-salmon text-off-black font-bold text-lg">
                    Live
                  </button>
                </a>
                <a
                  href="https://github.com/gavinwalters/TerraByte-Static/"
                  target="_blank"
                >
                  <button className="text-center rounderd-lg px-4 py-2 m-2 bg-salmon text-off-black font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
          {/* card container */}
          <div
            style={{ backgroundImage: `url(${CardsBJ})` }}
            className="shadow-lg shadow-ebony group container rounded-md flex justify-center text-center items-center mx-auto content-div"
          >
            {/* hover effects */}

            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-off-black tracking-wider">
                Vue.js Blackjack Game
              </span>
              <div className="pt-8 text-center">
                <a
                  href="https://main--lustrous-florentine-80f053.netlify.app/"
                  target="_blank"
                >
                  <button className="text-center rounderd-lg px-4 py-2 m-2 bg-salmon text-off-black font-bold text-lg">
                    Demo
                  </button>
                </a>
                <a
                  href="https://github.com/gavinwalters/Vue.js-Blackjack"
                  target="_blank"
                >
                  <button className="text-center rounderd-lg px-4 py-2 m-2 bg-salmon text-off-black font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
          {/* card container */}
          <div
            style={{ backgroundImage: `url(${CardsTH})` }}
            className="shadow-lg shadow-ebony group container rounded-md flex justify-center text-center items-center mx-auto content-div"
          >
            {/* hover effects */}

            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-off-black tracking-wider">
                Vue.js Texas Holdem Game
              </span>
              <div className="pt-8 text-center">
                <a
                  href="https://main--heartfelt-fenglisu-bd3b42.netlify.app/"
                  target="_blank"
                >
                  <button className="text-center rounderd-lg px-4 py-2 m-2 bg-salmon text-off-black font-bold text-lg">
                    Demo
                  </button>
                </a>
                <a
                  href="https://github.com/gavinwalters/Vue.js-Texas-Holdem"
                  target="_blank"
                >
                  <button className="text-center rounderd-lg px-4 py-2 m-2 bg-salmon text-off-black font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
